import React, { useMemo } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from 'react-router-dom';
import './App.scss';
import PrimarySearchAppBar from './views/TopBar/Topbar';
import Login from './views/SignUpLogin/Login';
import SideBar from './views/SideNav/SideBar';
import Mytrips from './views/Trip/Mytrips';
import PrivateRoute from './Utils/PrivateRoute';
import Profile from './views/Profile/Profile';
import BookingConfirm from './views/Map/bookingConfirm';
import SuccessPage from './views/Map/successPage';
import WrongPage from './views/Map/wrongPage';
import TripDetails from './views/Trip/TripDetails';
import MainG from './views/Map';

import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { CompanyProvider } from './context/CompanyContext';

const COMPANY_COLOR_MAP = {

  default: {
    primaryColorCode: '#66C9BB',
    secondaryColorCode: '#cccc',
    hover: '#eee',
  },
};

function App() {
  const companyId = localStorage.getItem('companyId') || 'default';

  const company = sessionStorage.getItem("companyDetails");

  let companyTheme;

  if (company) {
    companyTheme = JSON.parse(company)
  } else {
    companyTheme = COMPANY_COLOR_MAP.default;
  }



  const THEME = useMemo(() =>
    createTheme({
      typography: {
        fontFamily: `"Gill Sans", "Gill Sans MT","Roboto", "Helvetica", "Arial", sans-serif`,
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        useNextVariants: true
      },
      palette: {
        primary: {
          main: companyTheme?.primaryColorCode,
        },
        secondary: {
          main: companyTheme?.secondaryColorCode,
        },
      },
      overrides: {
        MuiAutocomplete: {
          root: {
            background: '#ffffff',
            '&::hover': {
              borderColor: companyTheme?.primaryColorCode,
            },
          },
          focused: {
            background: '#ffffff',
            '&::hover': {
              borderColor: companyTheme?.primaryColorCode,
            },
          },
        },
      },
    }), [companyTheme]
  );

  return (
    <CompanyProvider companyId={companyId}>
      <ThemeProvider theme={THEME}>
        <Router>
          <Routes>
            <Route exact path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <>
                  <PrimarySearchAppBar />
                  <MainG />
                </>
              }
            />
            <Route
              path="/sidenav"
              element={
                <PrivateRoute>
                  <SideBar />
                </PrivateRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route
              path="/bookingconfirmation"
              element={
                <PrivateRoute>
                  <BookingConfirm />
                </PrivateRoute>
              }
            />
            <Route
              path="/success"
              element={
                <PrivateRoute>
                  <SuccessPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/wrong"
              element={
                <PrivateRoute>
                  <WrongPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/mytrip"
              element={
                <PrivateRoute>
                  <Mytrips />
                </PrivateRoute>
              }
            />
            <Route
              path="mytrip/mytripdetails/:id/:passengerId"
              element={
                <PrivateRoute>
                  <TripDetails />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </ThemeProvider>
    </CompanyProvider>
  );
}

export default App;
